import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, Card, CardBody, Row, Col } from "reactstrap";
// toast
import { toast } from "react-toastify";
// service
import { getSalesAttendees } from "../../../../utils/services/sales";
// utils
import { buildAttendeeItems } from "./attendeeItems";
import { renderSafeHtml } from "./safeHtml";
// componentes
import { CopyButton } from "./CopyValue";

// Participantes de uma venda (inteegra_payment.attendees), um card por participante,
// com as propriedades do checkout rotuladas pelo formulário do evento.
export default function ModalAttendees(props) {
  const { isOpen, toggle, sale, token } = props;
  // dados
  const [attendees, setAttendees] = useState([]);
  const [fields, setFields] = useState([]);
  // carregamento
  const [loading, setLoading] = useState(true);

  // busca participantes e campos do formulário do evento
  function getList() {
    getSalesAttendees({ jwt: token, idSale: sale.id })
      .then((res) => {
        setAttendees(Array.isArray(res?.attendees) ? res.attendees : []);
        setFields(Array.isArray(res?.fields) ? res.fields : []);
      })
      .catch(() => toast.error("Não foi possível carregar os participantes"))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    getList();
  }, []);

  return (
    <Modal isOpen={isOpen} centered size="lg" scrollable>
      <ModalHeader toggle={toggle}>Participantes</ModalHeader>
      <ModalBody className="bg-light">
        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <div className="circle-loading" />
          </div>
        ) : attendees.length === 0 ? (
          <div className="text-center text-muted py-5">
            <i
              className="mdi mdi-account-off-outline d-block mb-2"
              style={{ fontSize: 40 }}
              aria-hidden="true"
            />
            Nenhum participante encontrado para esta venda
          </div>
        ) : (
          attendees.map((attendee, index) => {
            const items = buildAttendeeItems(attendee.info || {}, fields);

            return (
              <Card key={attendee.id} className="shadow-sm border-0 mb-3">
                <CardBody>
                  <div className="d-flex align-items-center justify-content-between gap-3 mb-3">
                    <div>
                      <div className="text-muted font-size-12">
                        Participante {index + 1} de {attendees.length}
                      </div>
                      {attendee.product_description && (
                        <div className="fw-semibold">
                          <i
                            className="mdi mdi-ticket-confirmation-outline me-1 text-muted"
                            aria-hidden="true"
                          />
                          {attendee.product_description}
                        </div>
                      )}
                    </div>
                    <span className="d-inline-flex align-items-center gap-2 flex-shrink-0">
                      <span
                        className={`badge rounded-pill px-3 py-1 text-nowrap ${
                          attendee.mice_id ? "badge-soft-success" : "badge-soft-secondary"
                        }`}
                        title={
                          attendee.mice_id
                            ? "ID do participante no MICE"
                            : "Ainda não integrado ao MICE"
                        }
                      >
                        {attendee.mice_id ? `ID MICE: ${attendee.mice_id}` : "Pendente"}
                      </span>
                      {attendee.mice_id && (
                        <CopyButton value={attendee.mice_id} label="ID do MICE" />
                      )}
                    </span>
                  </div>

                  {items.length === 0 ? (
                    <div className="text-muted font-size-13">
                      Sem dados preenchidos.
                    </div>
                  ) : (
                    <Row className="g-3">
                      {items.map((item) => (
                        <Col xs={12} md={6} key={item.name}>
                          <div className="text-muted font-size-12">
                            {renderSafeHtml(item.label)}
                          </div>
                          <span className="fw-semibold text-break">{item.value}</span>
                        </Col>
                      ))}
                    </Row>
                  )}
                </CardBody>
              </Card>
            );
          })
        )}
      </ModalBody>
    </Modal>
  );
}
